var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1C5 0.447715 5.44772 0 6 0H15C15.5523 0 16 0.447715 16 1C16 1.55228 15.5523 2 15 2H11.2352L6.86019 14H10C10.5523 14 11 14.4477 11 15C11 15.5523 10.5523 16 10 16H1C0.447715 16 0 15.5523 0 15C0 14.4477 0.447715 14 1 14H4.76481L9.13981 2H6C5.44772 2 5 1.55228 5 1Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic);
export default __webpack_public_path__ + "static/media/italic.c1503dfc09d60f4f31cdc55b38c03469.svg";
export { ForwardRef as ReactComponent };